export default function HeroSection() {
    return (
        <section className="min-h-screen flex items-center text-black justify-center px-4 py-20 bg-white">
            <div className="max-w-4xl mx-auto text-center">
                <h1 className="text-4xl sm:text-5xl md:text-6xl font-semibold leading-tight tracking-tight">
                    Share all your important links, in one simple{' '}
                    <span className="text-gray-400">place</span>. Choose from minimal templates and start sharing in{' '}
                    <span className="text-gray-400">seconds</span>.
                </h1>
                <p className="mt-8 text-xl text-gray-600 max-w-2xl mx-auto">
                    No more complicated setups or overwhelming features. Just pick a template, add your links, and share your page instantly.
                </p>
            </div>
        </section>
    )
}